// @flow

import Unit from '@/lib/unit';

export default class {
  id: ?number;
  title: string;
  description: ?string;
  level: string;
  isOpened: boolean;
  unit: ?Unit;

  constructor(params: {
    id?: number,
    title: string,
    description?: string,
    level?: string,
    unit?: Unit,
  }) {
    this.id = params.id || null;
    this.title = params.title;
    this.description = params.description || null;
    this.level = params.level || 'normal';
    this.isOpened = false;
    this.unit = params.unit;
  }

  open() {
    this.isOpened = true;
  }
}



// WEBPACK FOOTER //
// ./src/lib/notification/notification.js